import { OneCI } from '../interfaces/onec.interface'
import { OneCService } from '../services/onec.service'
import { OneCPayloadT } from '../types/onec.types'
import {
    OneCResponseT,
    OneCGetParamsT,
    ResendDispatcher,
    OneCDeliveryResponse,
    OneCDeliveryGetParams,
    ResendDelivery,
    SdtOrdersParams,
    SdtOrdersResponse,
    SdtOrdersResendParams,
    OneCTripsResponse,
    OneCGetTripsParams,
} from '@/core/types/one_c.types'

const oneCService = new OneCService()

class OneCRealisation implements OneCI {
    restoreOrders(onec_payload: OneCPayloadT): Promise<void> {
        return oneCService.restoreOrders(onec_payload)
    }

    resendTrips(onec_payload: OneCPayloadT): Promise<void> {
        return oneCService.resendTrips(onec_payload)
    }

    getList(params: OneCGetParamsT): Promise<OneCResponseT> {
        return oneCService.getList(params)
    }

    getTrips(params: OneCGetTripsParams): Promise<OneCTripsResponse> {
        return oneCService.getTrips(params)
    }

    getDeliveryList(params: OneCDeliveryGetParams): Promise<OneCDeliveryResponse> {
        return oneCService.getDeliveryList(params)
    }

    getSdtOrders(params: SdtOrdersParams): Promise<SdtOrdersResponse> {
        return oneCService.getSdtOrders(params)
    }

    resend(orderId: number): Promise<void> {
        return oneCService.resend(orderId)
    }

    resendDeliveryById(id: number): Promise<void> {
        return oneCService.resendDeliveryById(id)
    }

    resendDispatcher(payload: ResendDispatcher): Promise<void> {
        return oneCService.resendDispatcher(payload)
    }

    resendDelivery(payload: ResendDelivery): Promise<void> {
        return oneCService.resendDelivery(payload)
    }

    resendSdt(payload: SdtOrdersResendParams): Promise<void> {
        return oneCService.resendSdt(payload)
    }

    resendSdtOrder(id: number): Promise<void> {
        return oneCService.resendSdtOrder(id)
    }

    syncOnec(form_data: FormData): Promise<void> {
        return oneCService.syncOnec(form_data)
    }
}

export const onec = new OneCRealisation()
